import script from "./order-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./order-list.vue?vue&type=script&lang=ts&setup=true"

import "./order-list.vue?vue&type=style&index=0&id=f9420d2e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9420d2e"]])

export default __exports__